import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RESTService } from 'src/app/common/services/rest.service';

@Injectable({
    providedIn: 'root'
})
export class CustomerService {
    constructor(private restService: RESTService) { } 

    paymentHubRequest(body: any): Observable<any> {
        return this.restService.post("", body);
    }

    getPayloadData(transactionId: string) {
        let parameters = new HttpParams();
        return this.restService.get(RESTService.API_PAYLOAD + '/' + transactionId, parameters);
    }

    accounts(transactionId: string) {
        let parameters = new HttpParams().set(RESTService.REQUEST_PARAM_TRANSACTION_ID, transactionId);
        return this.restService.get(RESTService.API_ACCOUNT, parameters);
    }

}
